import React from 'react';
import Isvg from 'react-inlinesvg';

import { Card, CardTitle } from 'components/Card';
import Callout from 'components/Callout';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';
import { PlainSwitch } from 'components/Switch';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import messages from '../Notifications.messages';
import { useMarketingSubscriptionQuery, useUpdateMarketingSubscriptionMutation } from './useMarketingSubscription';
import './MarketingEmails.scss';

const { block, element } = bem('marketing-emails');

const MarketingEmails = () => {
  const { data: isSubscribed, isLoading } = useMarketingSubscriptionQuery();
  const { mutate, isLoading: isUpdating } = useUpdateMarketingSubscriptionMutation();

  return (
    <Card className={block()}>
      <Message as={CardTitle} message={messages.marketingTitle} />
      <Callout className={element('callout')} icon={<Isvg src={ICONS.info} />}>
        <Message message={messages.marketingCallout} />
      </Callout>
      {isLoading ? (
        <LoadingDots />
      ) : (
        <div className={element('toggle')}>
          <PlainSwitch
            name="marketingEmails"
            checked={!!isSubscribed}
            disabled={isUpdating}
            inputProps={{ onChange: ({ target: { checked } }) => mutate(checked) }}>
            {() => <Message className="ml-s" message={messages.marketingToggleLabel} />}
          </PlainSwitch>
        </div>
      )}
    </Card>
  );
};

export default MarketingEmails;
